import { CommunicationChannel } from '@lightdash/common';

export const getChannel = (channel: string) => {
    if (channel === 'email') {
        return CommunicationChannel.EMAIL;
    }
    if (channel === 'sms') {
        return CommunicationChannel.SMS;
    }
    if (channel === 'whatsapp') {
        return CommunicationChannel.WHATSAPP;
    }
    return CommunicationChannel.ANY;
};
